var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dark || _vm.inverted)?_c('v-img',_vm._b({attrs:{"src":"https://parked.blob.core.windows.net/ownli/www/logos/logo.png"}},'v-img',_vm.$attrs,false)):_c('v-img',_vm._b({attrs:{"src":"https://parked.blob.core.windows.net/ownli/www/logos/logo.png"}},'v-img',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }